/* eslint-disable no-plusplus */
import getStars from '../../../utils/getStars';

const template = players => players.filter(player => player.id).map(player => `
  <div class="radio-player col-6">
    <input required class="radio-player__input" name="nft_id" type="radio" data-generation="${player?.generation}" value="${player.id}" id="player-${player.id}" />
    <label class="radio-player__label d-flex align-items-center flex-column" for="player-${player?.id}">
      <div class="radio-player__image" style="background-image: url(${player.thumbnail}); ${player.generation == 2 ? 'background-color: #ffdf00dd;' : ''}"> </div>
      <div class="text-center">
        <div class="">${player?.name}</div>
        <div class="">${player?.rarity}</div>
        <div class="">${getStars(player?.star)}</div>
      </div>
    </label>
  </div>
`).join('');

export default template;
